import React, { useState } from "react";
import Eto from "../src/assests/logo_1.png";

export default function FeedBackScreen() {
  const [selectedCategories, setSelectedCategories] = useState(["Others"]); // "Others" is always selected
  const [selectedFeedbackOptions, setSelectedFeedbackOptions] = useState([]);
  const [customFeedback, setCustomFeedback] = useState("");

  const feedbackMessages = {
    Driver: [
      "Rude",
      "Refused shortcut",
      "Misbehaved",
      "Unsafe driving",
      "Demanded tip",
    ],
    Vehicle: ["Not well maintained", "Broke down during trip", "Accident"],
    Application: ["Difficult to use", "Inaccurate", "Update issues"],
  };

  const handleCategoryChange = (category) => {
    if (category === "Others") return;
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((item) => item !== category)
        : [...prev, category]
    );
  };

  const handleFeedbackOptionChange = (option) => {
    setSelectedFeedbackOptions((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option]
    );
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-blue-50 p-4">
      {/* Logo */}
      <img src={Eto} width={120} height={100} alt="ETO" className="mb-4" />

      {/* Title & Description */}
      <h2 className="text-lg font-semibold text-blue-700">
        Your Feedback Matters!
      </h2>
      <p className="mt-2 text-sm text-gray-600 text-center px-6">
        Help us improve your ride experience by sharing your valuable feedback.
        {/* We tried our best to provide you a comfortable ride. Please share your feedback to better our services. */}
      </p>

      {/* Feedback Selection */}
      <div className="bg-white shadow-md rounded-lg p-4 mt-4 w-full max-w-md">
        <h3 className="text-md font-semibold text-gray-700 mb-3">
          Feedback Category:
        </h3>

        {["Driver", "Vehicle", "Application", "Others"].map((category) => (
          <div key={category} className="mb-3">
            <label className="flex items-center gap-2 text-gray-700">
              <input
                type="checkbox"
                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                value={category}
                checked={selectedCategories.includes(category)}
                onChange={() => handleCategoryChange(category)}
                disabled={category === "Others"} // Keep "Others" always selected
              />
              {category}
            </label>

            {/* Show related feedback options */}
            {selectedCategories.includes(category) && category !== "Others" && (
              <div className="mt-2 ml-6 space-y-2">
                {feedbackMessages[category].map((option) => (
                  <label
                    key={option}
                    className="flex items-center gap-2 text-gray-600"
                  >
                    <input
                      type="checkbox"
                      className="w-4 h-4 text-blue-500 border-gray-300 rounded focus:ring-blue-400"
                      value={option}
                      checked={selectedFeedbackOptions.includes(option)}
                      onChange={() => handleFeedbackOptionChange(option)}
                    />
                    {option}
                  </label>
                ))}
              </div>
            )}
          </div>
        ))}

        {/* Always visible text box for "Others" */}
        <div className="mt-4">
          <label className="block text-gray-700 font-medium mb-1">
            Other Feedback:
          </label>
          <textarea
            className="w-full border border-gray-300 p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            placeholder="Enter your feedback..."
            maxLength={280}
            rows={3}
            value={customFeedback}
            onChange={(e) => setCustomFeedback(e.target.value)}
          ></textarea>
        </div>

        {/* Submit Button */}
        <div className="flex justify-center items-center">
          <button className="mt-6 w-1/2 bg-green-700 text-white font-medium py-2 rounded-lg shadow-md transition uppercase">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
